var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90234 3.72949C9.28457 6.18283 11.2757 8.05838 13.7468 8.30723",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7731 8.2802L14.9642 7.018C16.2265 5.68467 16.7954 4.16467 14.8309 2.30689C12.8665 0.458001 11.382 1.10689 10.1198 2.44022L2.82198 10.1646C2.54643 10.458 2.27976 11.0358 2.22643 11.4358L1.89754 14.3158C1.78198 15.3558 2.52865 16.0669 3.55976 15.8891L6.42198 15.4002C6.82198 15.3291 7.38202 15.0358 7.65757 14.7335L10.1687 12.018",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.7959H8.77778",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 18.7959H16.9997",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.a968bd0ea4ca94d63ef1059e007c1136.svg";
export { ForwardRef as ReactComponent };